import React, {useState, useEffect} from 'react';
import {receiptPdfFilename} from '../../../utils/receiptPdfFilename';
import {withTranslation} from 'react-i18next';
import {Button} from "primereact/button";
import {Sidebar} from "primereact/sidebar";
import {useHistory, useParams} from "react-router-dom";
import {TabView, TabPanel} from 'primereact/tabview';
import {Dialog} from "primereact/dialog";
import {Panel} from "primereact/panel";
import download from "js-file-download";
import axios from "axios";

import ReceiptFormComponent from "../../../components/2.1/finance/receipt/ReceiptFormComponent";
import ReceiptListComponent from "../../../components/2.1/finance/receipt/ReceiptListComponent";
import ReceiptCostImportComponent from "../../../components/2.0/receipt/ReceiptCostImportComponent";
import ReceiptgroupListService from "../../../components/2.0/_services/receiptgroup/ReceiptgroupListService";
import ReceiptShowComponent from "../../../components/2.1/finance/receipt/ReceiptShowComponent";
import ReceiptSzamlazzhuImportComponent from "../../../components/2.0/receipt/ReceiptSzamlazzhuImportComponent";
import ReceiptSendComponent from "../../../components/2.0/receipt/ReceiptSendComponent";
import RetentioncategoryListComponent
  from "../../../components/2.1/finance/retention-category/RetentioncategoryListComponent";
import RetentioncategoryFormComponent
  from "../../../components/2.1/finance/retention-category/RetentioncategoryFormComponent";
import RetentionListComponent from "../../../components/2.1/finance/retention/RetentionListComponent";
import RetentionFormComponent from "../../../components/2.1/finance/retention/RetentionFormComponent";
import ReceiptgroupFormComponent from '../../../components/2.1/finance/receiptgroup/ReceiptgroupFormComponent';
import ReceiptgroupListComponent from '../../../components/2.1/finance/receiptgroup/ReceiptgroupListComponent';
import PaymentmethodListComponent from '../../../components/2.1/finance/paymentmethod/PaymentmethodListComponent';
import PaymentmethodFormComponent from '../../../components/2.1/finance/paymentmethod/PaymentmethodFormComponent';
import CosttypeListComponent from "../../../components/2.1/finance/costtype/CosttypeListComponent";
import CosttypeFormComponent from "../../../components/2.1/finance/costtype/CosttypeFormComponent";
import FinanceDashboardComponent from "../../../components/2.1/finance/FinanceDashboardComponent";
import BanktransactionListComponent from '../../../components/2.1/finance/transaction/BanktransactionListComponent';
import BanktransactionShowComponent from '../../../components/2.1/finance/transaction/BanktransactionShowComponent';
import PartnerListComponent from "../../../components/2.0/partner/PartnerListComponent";
import BankaccountNumberListComponent from "../../../components/2.1/finance/bankaccountnumber/BankaccountNumberListComponent";
import BankaccountNumberFormComponent from "../../../components/2.1/finance/bankaccountnumber/BankaccountNumberFormComponent";
import VatrateListComponent from "../../../components/2.1/finance/vatrate/VatrateListComponent";
import VatrateFormComponent from "../../../components/2.1/finance/vatrate/VatrateFormComponent";
import CostcenterFormComponent from '../../../components/2.1/finance/constcenter/CostcenterFormComponent';
import CostcenterListComponent from '../../../components/2.1/finance/constcenter/CostcenterListComponent';
import CostitemFormComponent from '../../../components/2.1/finance/costitem/CostitemFormComponent';
import CostitemListComponent from '../../../components/2.1/finance/costitem/CostitemListComponent';
import CostitemShowComponent from '../../../components/2.1/finance/costitem/CostitemShowComponent';
import CostallocationListComponent from '../../../components/2.1/finance/costitem/CostallocationListComponent';
import CostallocationApproveListComponent from '../../../components/2.1/finance/costallocationapprove/CostallocationApproveListComponent';
import InventorydocumentListComponent from "../../../components/2.1/inventory/inventorydocument/InventorydocumentListComponent";
import ProfitcenterListComponent from '../../../components/2.1/finance/profitcenter/ProfitcenterListComponent';
import ProfitcenterFormComponent from '../../../components/2.1/finance/profitcenter/ProfitcenterFormComponent';

export const FinanceDashboardPage = (props) => {

  const history = useHistory();
  const {entity, action, id} = useParams();

  const [receiptgroups, setReceiptgroups] = useState([]);
  const [currentReceipt, setCurrentReceipt] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [loading, setLoading] = useState(false);

  const urlVars = window.App && typeof window.App.urlVars === 'function'
    ? window.App.urlVars()
    : {};

  const fromReceiptGroup = urlVars.from === 'receiptgroup';
  const receiptGroupFromUrl = urlVars.receipt_group
    ? Number(urlVars.receipt_group)
    : null;
  const receiptTypeFromUrl = urlVars.receipt_type || null;
  const receiptGroupNameFromUrl = urlVars.receipt_group_name
    ? decodeURIComponent(urlVars.receipt_group_name)
    : null;

  const receiptForActions = currentReceipt || history.location.state || null;

  const canDeleteReceipt = (() => {
    const r = receiptForActions;
    if (!r?.id) return false;
    if (r.draft === true) return true;
    if (r.external === true) return false;
    if (r.receipt_type === 'FEE_REQUEST') return true;
    return false;
  })();

  const canDownloadReceipt = (() => {
    const r = receiptForActions;
    return !!(r?.id && r?.outgoing === true);
  })();

  const fetchReceiptDownloadPdfService = (receiptId) => {
    return axios.get(
      process.env.REACT_APP_API_HOST + "/api/v2/receipt/" + receiptId + "/download/pdf",
      {
        responseType: 'blob',
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      }
    );
  };

  const handleDownload = () => {
    const r = receiptForActions;
    if (!r?.id) return;
    fetchReceiptDownloadPdfService(r.id)
      .then(response => {
        window.App.toastShow('success', 'Sikeres letöltés!');
        download(
          response.data,
          receiptPdfFilename(r)
        );
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      });
  };

  const handleDelete = () => {
    const r = receiptForActions;
    if (!r?.id) return;
    if (window.confirm('A törlés megerősítésére van szükség!')) {
      setLoading(true);
      // ReceiptDeleteService(r.id)
      axios.delete(
        process.env.REACT_APP_API_HOST + "/api/v2/receipt/" + r.id,
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
              'App-Network': localStorage.getItem("networkId")
            }
          }
        )
        .then(() => {
          window.App.toastShow('success', 'Sikeres törlés!');
          window.App.setState({
            rerenderReceiptList: true,
            sidebarReceiptUpdate: false,
            sidebarReceiptCreate: false,
            sidebarReceiptShow: false,
          });
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        })
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    window.App.pageHeight()
    setTimeout(function () {
      if (document.getElementsByClassName('activeMenu') && document.getElementsByClassName('activeMenu')[0]) {
        document.getElementsByClassName('activeMenu')[0].classList.remove("activeMenu")
      }
      if (document.getElementsByClassName('finance') && document.getElementsByClassName('finance')[0]) {
        document.getElementsByClassName('finance')[0].classList.add("activeMenu")
      }
    }, 1000)
    if (
      document.getElementById('tabScroll')
      && document.getElementById('tabScroll').children
      && document.getElementById('tabScroll').children[0]
      && document.getElementById('tabScroll').children[0].querySelector("li:not(.p-disabled)").children[0]
    ) {
      document.getElementById('tabScroll').children[0].querySelector("li:not(.p-disabled)").children[0].click()
    }
    document.title = 'Pénzügy' + ' - ' + process.env.REACT_APP_TITLE;
    ReceiptgroupListService(
      JSON.stringify({
        first: 0,
        rows: 9999,
        page: 0,
      })
    )
      .then(response => {
        if (response.data && response.data.items) {
          setReceiptgroups(response.data.items)
        } else if (response.data && Array.isArray(response.data)) {
          setReceiptgroups(response.data)
        } else {
          console.warn('ReceiptgroupListService nem adta vissza a várt adatokat:', response)
          setReceiptgroups([])
        }
      })
      .catch(error => {
        console.error('ReceiptgroupListService hiba:', error)
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        setReceiptgroups([])
    })
  }, []);

  useEffect(() => {
    if (window.App.state.rerenderReceiptList === true) {
        setRefreshTrigger(prev => prev + 1);
    }
  }, [window.App.state.rerenderReceiptList]);

  return (
    <div className="ModuleDashboardPage DashboardPage p-component p-p-3 ">
      {entity === 'dashboard' &&
        <div className={"PageContent p-p-5 p-mx-auto"}>
          <FinanceDashboardComponent />
        </div>
      }














      {/* REFAKTORÁLVA 2.1-BE */}
      {entity === 'retention' &&
        <div className={"PageContent p-p-5 p-mx-auto"}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
              <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                Visszatartások listája
              </h2>
            </div>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                  </span>
              {/*<a onClick={() => {*/}
              {/*  history.push('/finance/retention/create')*/}
              {/*}}*/}
              {/*   className={"p-button  p-button-success p-ml-2"}>*/}
              {/*  <i className={"pi pi-plus"}></i>*/}
              {/*  &nbsp;*/}
              {/*  Új visszatartás*/}
              {/*</a>*/}
            </div>
          </div>
          <Panel>
            <RetentionListComponent/>
          </Panel>
        </div>
      }
      {entity === 'retention' && (action === 'create' || action === 'update') &&
        <Sidebar position="left"
                 showCloseIcon={false}
                 visible={action === 'create' || action === 'update'}
                 closeOnEscape={true}
                 style={{width: '780px'}}
                 onHide={() => {
                   history.push('/finance/retention')
                 }}>
          <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  Visszatartás {id && id !== 'undefined' ? (<>módosítása</>) : (<>létrehozása</>)}
                </h2>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                <a onClick={() => {
                  history.push('/finance/retention')
                }}
                   className={"p-button  p-button-secondary p-ml-2"}>
                  <i className={"pi pi-arrow-left"}></i>
                  &nbsp;
                  Vissza
                </a>
              </div>
            </div>
            <Panel>
              <RetentionFormComponent backlink={'/finance/retention'}/>
            </Panel>
          </div>
        </Sidebar>
      }
      {entity === 'retention-category' &&
        <div className={"PageContent p-p-5 p-mx-auto"}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
              <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                Visszatartás kategóriák
              </h2>
            </div>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                  </span>
              <a onClick={() => {
                history.push('/finance/retention-category/create')
              }}
                 className={"p-button  p-button-success p-ml-2"}>
                <i className={"pi pi-plus"}></i>
                &nbsp;
                Új visszatartás kategória
              </a>
            </div>
          </div>
          <Panel>
            <RetentioncategoryListComponent/>
          </Panel>
        </div>
      }
      {entity === 'retention-category' && (action === 'create' || action === 'update') &&
        <Sidebar position="left"
                 showCloseIcon={false}
                 visible={action === 'create' || action === 'update'}
                 closeOnEscape={true}
                 style={{width: '780px'}}
                 onHide={() => {
                   history.push('/finance/retention-category')
                 }}>
          <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  Visszatartás {id && id !== 'undefined' ? (<>módosítása</>) : (<>létrehozása</>)}
                </h2>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                <a onClick={() => {
                  history.push('/finance/retention-category')
                }}
                   className={"p-button  p-button-secondary p-ml-2"}>
                  <i className={"pi pi-arrow-left"}></i>
                  &nbsp;
                  Vissza
                </a>
              </div>
            </div>
            <Panel>
              <RetentioncategoryFormComponent backlink={'/finance/retention-category'}/>
            </Panel>
          </div>
        </Sidebar>
      }























      {/* REFAKTORÁLVA 2.1-BE */}
      {entity === 'book' &&
        <>
          <Panel>
            <ReceiptgroupListComponent view="simple"/>
          </Panel>
          <Sidebar position="left" visible={window.App.state.sidebarReceiptgroupCreate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarReceiptgroupCreate: false})
                   }}>
            <h2 className={"text-primary"}>Új bizonylat tömb</h2>
            <ReceiptgroupFormComponent method="post"/>
          </Sidebar>
          <Sidebar position="left" visible={window.App.state.sidebarReceiptgroupUpdate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarReceiptgroupUpdate: false})
                   }}>
            <h2 className={"text-primary"}>Bizonylat tömb módosítása</h2>
            <ReceiptgroupFormComponent method="put" initialValues={window.App.state.props}/>
          </Sidebar>
        </>
      }













      {/* REFAKTORÁLVA 2.1-RE */}
      {entity === 'profit-center' && (!action || action === 'update' || action === 'create') &&
        <div className={"PageContent p-p-5 p-mx-auto"}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
              <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                Üzletágak listája
              </h2>
            </div>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
              <span className={"p-mr-2"}>

              </span>
              <a onClick={() => {
                history.push('/finance/profit-center/create')
              }}
                  className={"p-button  p-button-success p-ml-2"}>
                <i className={"pi pi-plus"}></i>
                &nbsp;
                Új üzletág
              </a>
            </div>
          </div>
          <Panel>
            <ProfitcenterListComponent backlink={'/finance/profit-center'}/>
          </Panel>
        </div>
      }
      {entity === 'profit-center' && (action === 'create' || action === 'update') &&
        <Sidebar position="left"
                  showCloseIcon={false}
                  visible={action === 'create' || action === 'update'}
                  closeOnEscape={true}
                  style={{width: '780px'}}
                  onHide={() => {
                    if (action === 'create' || action === 'update') {
                      history.push('/finance/profit-center')
                    }
                  }}>
          <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  Üzletág {id ? (<>módosítása</>) : (<>létrehozása</>)}
                </h2>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
              <span className={"p-mr-2"}>

              </span>
                <a onClick={() => {
                  if (action === 'create' || action === 'update') {
                    history.push('/finance/profit-center')
                  }
                }}
                    className={"p-button  p-button-secondary p-ml-2"}>
                  <i className={"pi pi-arrow-left"}></i>
                  &nbsp;
                  Vissza
                </a>
              </div>
            </div>
            <Panel>
              {(action === 'create' || action === 'update') &&
                <ProfitcenterFormComponent backlink={'/finance/profit-center'}/>
              }
            </Panel>
          </div>
        </Sidebar>
      }

























      {/* REFAKTORÁLVA 2.1-RE */}
      {entity === 'payment-method' &&
        <>
          <Panel>
            <PaymentmethodListComponent view="simple"/>
          </Panel>
          <Sidebar position="left" visible={window.App.state.sidebarPaymentmethodCreate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarPaymentmethodCreate: false})
                   }}>
            <h2 className={"text-primary"}>Új fizetési mód</h2>
            <PaymentmethodFormComponent method="post"/>
          </Sidebar>
          <Sidebar position="left" visible={window.App.state.sidebarPaymentmethodUpdate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarPaymentmethodUpdate: false})
                   }}>
            <h2 className={"text-primary"}>Fizetési mód módosítása</h2>
            <PaymentmethodFormComponent method="put" initialValues={window.App.state.props}/>
          </Sidebar>
        </>
      }




























      {/* REFAKTORÁLVA 2.1-RE */}
      {entity === 'cost-type' &&
        <>
          <Panel>
            <CosttypeListComponent view="simple"/>
          </Panel>
          <Sidebar position="left" visible={window.App.state.sidebarCosttypeCreate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarCosttypeCreate: false})
                   }}>
            <h2 className={"text-primary"}>Új költségnem</h2>
            <CosttypeFormComponent method="post"/>
          </Sidebar>
          <Sidebar position="left" visible={window.App.state.sidebarCosttypeUpdate} closeOnEscape={true}
                   style={{width: '780px'}}
                   onHide={() => {
                     window.App.setState({sidebarCosttypeUpdate: false})
                   }}>
            <h2 className={"text-primary"}>Költségnem módosítása</h2>
            <CosttypeFormComponent method="put" initialValues={window.App.state.props}/>
          </Sidebar>
        </>
      }























      {/* REFAKTORÁLVA 2.1-RE */}
      {entity === 'cost-center' && (!action || action === 'update' || action === 'create') &&
        <div className={"PageContent p-p-5 p-mx-auto"}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
              <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                Költséghelyek listája
              </h2>
            </div>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
              <span className={"p-mr-2"}>

              </span>
              <a onClick={() => {
                history.push('/finance/cost-center/create')
              }}
                  className={"p-button  p-button-success p-ml-2"}>
                <i className={"pi pi-plus"}></i>
                &nbsp;
                Új költséghely
              </a>
            </div>
          </div>
          <Panel>
            <CostcenterListComponent backlink={'/finance/cost-center'}/>
          </Panel>
        </div>
      }
























      {/* REFAKTORÁLVA 2.1-RE */}
      {entity === 'receipt' && action === 'read' && (
        <Sidebar
          position="left"
          visible={window.App.state.sidebarReceiptUpdate}
          closeOnEscape
          style={{ width: '98%' }}
          onHide={() => {
            window.App.setState({
              sidebarReceiptUpdate: false,
              rerenderReceiptList: true,
              newPartnerId: null,
              newPartnerName: null
            });
            setRefreshTrigger(prev => prev + 1);
          }}
        >
          <ReceiptFormComponent method="put" initialValues={window.App.state.props} />
        </Sidebar>
      )}
      {entity === 'receipt' && action === 'read' &&
        <div className={"PageContent p-p-5 p-mx-auto"}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
              <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                Bizonylat megtekintése
              </h2>
            </div>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
              {canDeleteReceipt && (
                <Button
                  type="button"
                  label="Törlés"
                  icon="pi pi-trash"
                  className="p-button-danger p-ml-2"
                  loading={loading}
                  onClick={handleDelete}
                />
              )}
              <Button
                icon="pi pi-download"
                className="p-button p-ml-2"
                label="Letöltés"
                disabled={!canDownloadReceipt}
                onClick={handleDownload}
              />
              <Button 
                type="button" 
                label="Szerkesztés" 
                icon="pi pi-pencil" 
                className="p-button-warning p-ml-2"
                disabled={history.location.state?.draft !== true && currentReceipt?.draft !== true} 
                onClick={() => {
                  const dataToEdit = currentReceipt || history.location.state;
                  if (!dataToEdit) return;
                  let sidebarStateKey = 'sidebarReceiptUpdate';
                  const rType = dataToEdit.receipt_type;
                  if (rType === 'CUSTOMER_INVOICE' || rType === 'SUPPLIER_INVOICE' || rType === 'INVOICE') {
                      sidebarStateKey = 'sidebarReceiptUpdate';
                  } else if (['CUSTOMER_FEE_REQUEST', 'FEE_REQUEST', 'SUPPLIER_FEE_REQUEST'].includes(rType)) {
                      sidebarStateKey = 'sidebarReceiptFeeRequestCreate';
                  } else if (rType === 'DELIVERY_NOTE') {
                      sidebarStateKey = 'sidebarReceiptDeliveryNoteCreate';
                  }
                  window.App.setState({
                    [sidebarStateKey]: true,
                    props: { ...dataToEdit, id: Number(id) }
                  });
                }}
              />
              <a onClick={() => {
                const from = history.location?.state?.from;
                  if (from) {
                    history.push(from); 
                  } else {
                    history.goBack();
                  }
                }}
                className={"p-button  p-button-secondary p-ml-2"}>
                <i className={"pi pi-arrow-left"}></i>
                &nbsp;
                Vissza
              </a>
            </div>
          </div>
          <Panel>
            <ReceiptShowComponent key={`${action}-${id}`} initialValues={{id: Number(id)}} onLoad={(data) => setCurrentReceipt(data)} refreshTrigger={refreshTrigger}/>
          </Panel>
        </div>
      }


























      
      {/* REFAKTORÁLVA 2.1-RE */}
      {entity === 'bank-transaction' && !action && (
        <div className="PageContent p-p-5 p-mx-auto">
          <div className="p-grid">
            <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
              <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                Bank tranzakciók
              </h2>
            </div>
            {/* <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
              <a
                onClick={() => {
                  history.push('/finance/bank-transaction/create');
                }}
                className="p-button p-button-success p-ml-2"
              >
                <i className="pi pi-plus"></i>
                &nbsp;
                Új tranzakció
              </a>
            </div> */}
          </div>

          <Panel>
            <BanktransactionListComponent backlink={'/finance/bank-transaction'} />
          </Panel>
        </div>
      )}

      {entity === 'bank-transaction' && action === 'edit' && (
        <div className="PageContent p-p-5 p-mx-auto">
          <div className="p-grid">
            <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
              <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                Bank tranzakció megtekintése
              </h2>
            </div>

            <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
              <a
                onClick={() => {
                  history.push('/finance/bank-transaction');
                }}
                className="p-button p-button-secondary p-ml-2"
              >
                <i className="pi pi-arrow-left"></i>
                &nbsp;
                Vissza
              </a>
            </div>
          </div>

          <Panel>
            <BanktransactionShowComponent backlink={'/finance/bank-transaction'} />
          </Panel>
        </div>
      )}

      {entity === 'cost-item' && (!action || action === 'update' || action === 'create') &&
        <div className={"PageContent p-p-5 p-mx-auto"}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
              <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                Költség tételek listája
              </h2>
            </div>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
              <span className={"p-mr-2"}>

              </span>
              {/* <a onClick={() => {
                history.push('/finance/cost-item/create')
              }}
                  className={"p-button  p-button-success p-ml-2"}>
                <i className={"pi pi-plus"}></i>
                &nbsp;
                Új költség tétel
              </a> */}
            </div>
          </div>
          <Panel>
            <CostitemListComponent backlink={'/finance/cost-item'}/>
          </Panel>
        </div>
      }

      {entity === 'cost-item' && action === 'read' &&
        <div className={"PageContent p-p-5 p-mx-auto"}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
              <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                Költség tétel megtekintése
              </h2>
            </div>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
              <a onClick={() => {
                history.push('/finance/cost-item')
              }}
                className={"p-button  p-button-secondary p-ml-2"}>
                <i className={"pi pi-arrow-left"}></i>
                &nbsp;
                Vissza
              </a>
            </div>
          </div>

          <Panel>
            <TabView renderActiveOnly="true" className="tabview-header-icon menu" style={{border: 'none'}}>
              <TabPanel header="Alapadatok" leftIcon="pi pi-list">
                <div className={"p-grid"}>
                  <div className={"p-col"}>
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          Megnevezés
                        </h3>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                      </div>
                    </div>
                    <CostitemShowComponent />
                  </div>
                </div>
              </TabPanel>

              <TabPanel header="Költségfelosztás" leftIcon="pi pi-list">
                <CostallocationListComponent costItemAmount={window.App.state?.props?.amount} />
              </TabPanel>
            </TabView>
          </Panel>
        </div>
      }



















      {/* REFAKTORÁLVA 2.1-RE */}
      {entity === 'cost-allocation' && (!action || action === 'update' || action === 'create') &&
        <div className={"PageContent p-p-5 p-mx-auto"}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
              <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                Költség jóváhagyás
              </h2>
            </div>
          </div>
          <Panel>
            <CostallocationApproveListComponent backlink={'/cost-allocation'}/>
          </Panel>
        </div>
      }
      {/* <Sidebar
        position="bottom"
        visible={window.App.urlVars().search === 'partner'}
        closeOnEscape={true}
        style={{ width: '100%', height: '80%' }}
        onHide={() => {
          history.push('/finance/bank-transaction/edit/' + id)
        }}
      >
        <div className="p-grid p-mt-3">
          <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
            <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
              Partner keresése
            </h3>
          </div>
          <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
          </div>
        </div>

        <Panel>
          <PartnerListComponent
          view="search"
            backlink={'/finance/bank-transaction/edit/' + id}
          />
        </Panel>
      </Sidebar> */}
      <Sidebar
        position="bottom"
        visible={window.App.urlVars().search === 'partner'}
        closeOnEscape
        style={{ width: '100%', height: '80%' }}
        onHide={() => {
          const vars = window.App.urlVars();
          const next = { ...vars };
          delete next.search;
          let q = '?';
          Object.entries(next).forEach(([k, v]) => {
            if (v !== undefined && v !== null && v !== '') q += `${k}=${v}&`;
          });
          window.location.hash = window.location.hash.replace(/\?.*$/, "") + q;
        }}
      >
        <div className="p-grid p-mt-3">
          <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
            <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
              Partner keresése
            </h3>
          </div>
        </div>
        <Panel>
          <PartnerListComponent
            view="search"
            backlink={window.location.hash.replace('#', '').replace(/\?.*$/, '')}
          />
        </Panel>
      </Sidebar>
      <Sidebar
        position="bottom"
        visible={window.App.urlVars().search === 'receiptRelationReceipt'}
        closeOnEscape={true}
        style={{ width: '100%', height: '80%' }}
        onHide={() => {
          const basePath = history.location.pathname;
          const params = new URLSearchParams(history.location.search);
          params.delete('search');
          history.push(`${basePath}?${params.toString()}`);
        }}
      >
        <div className="p-grid p-mt-3">
          <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
            <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
              Számla tallózása
            </h3>
          </div>
        </div>
        <Panel>
          <ReceiptListComponent
            view="search"
            backlink={`${history.location.pathname}?${new URLSearchParams(history.location.search).toString()}`.replace(/([&?])search=[^&]+/, '')}
            pickParam="related_receipt"
          />
        </Panel>
      </Sidebar>
      <Sidebar
        position="bottom"
        visible={window.App.urlVars().search === 'receiptRelationInvDoc'}
        closeOnEscape={true}
        style={{ width: '100%', height: '80%' }}
        onHide={() => {
          const basePath = history.location.pathname;
          const params = new URLSearchParams(history.location.search);
          params.delete('search');
          history.push(`${basePath}?${params.toString()}`);
        }}
      >
        <div className="p-grid p-mt-3">
          <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
            <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
              Szállítólevél tallózása
            </h3>
          </div>
        </div>
        <Panel>
          <InventorydocumentListComponent
            view="search"
            backlink={`${history.location.pathname}?${new URLSearchParams(history.location.search).toString()}`.replace(/([&?])search=[^&]+/, '')}
            pickParam="inventory_document"
          />
        </Panel>
      </Sidebar>
      {entity === 'bank-account' && (!action || action === 'update' || action === 'create') &&
        <div className={"PageContent p-p-5 p-mx-auto"}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
              <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                Bankszámlaszámok listája
              </h2>
            </div>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
              <span className={"p-mr-2"}>

              </span>
              <a onClick={() => {
                history.push('/finance/bank-account/create')
              }}
                  className={"p-button  p-button-success p-ml-2"}>
                <i className={"pi pi-plus"}></i>
                &nbsp;
                Új Bankszámlaszám
              </a>
            </div>
          </div>
          <Panel>
            <BankaccountNumberListComponent backlink={'/finance/bank-account'}/>
          </Panel>
        </div>
      }
      {entity === 'bank-account' && (action === 'create' || action === 'update') &&
        <Sidebar position="left"
                  showCloseIcon={false}
                  visible={action === 'create' || action === 'update'}
                  closeOnEscape={true}
                  style={{width: '780px'}}
                  onHide={() => {
                    if (action === 'create' || action === 'update') {
                      history.push('/finance/bank-account')
                    }
                  }}>
          <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  Bankszámlaszám {id ? (<>módosítása</>) : (<>létrehozása</>)}
                </h2>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
              <span className={"p-mr-2"}>

              </span>
                <a onClick={() => {
                  if (action === 'create' || action === 'update') {
                    history.push('/finance/bank-account')
                  }
                }}
                    className={"p-button  p-button-secondary p-ml-2"}>
                  <i className={"pi pi-arrow-left"}></i>
                  &nbsp;
                  Vissza
                </a>
              </div>
            </div>
            <Panel>
              {(action === 'create' || action === 'update') &&
                <BankaccountNumberFormComponent backlink={'/finance/bank-account'}/>
              }
            </Panel>
          </div>
        </Sidebar>
      }

      {entity === 'cost-item' && (action === 'create' || action === 'update') &&
                  <Sidebar position="left"
                           showCloseIcon={false}
                           visible={action === 'create' || action === 'update'}
                           closeOnEscape={true}
                           style={{width: '780px'}}
                           onHide={() => {
                             if (action === 'create' || action === 'update') {
                               history.push('/finance/cost-item')
                             }
                           }}>
                    <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                          <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                            Költség tétel {id ? (<>módosítása</>) : (<>létrehozása</>)}
                          </h2>
                        </div>
                        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <span className={"p-mr-2"}>
      
                        </span>
                          <a onClick={() => {
                            if (action === 'create' || action === 'update') {
                              history.push('/finance/cost-item')
                            }
                          }}
                             className={"p-button  p-button-secondary p-ml-2"}>
                            <i className={"pi pi-arrow-left"}></i>
                            &nbsp;
                            Vissza
                          </a>
                        </div>
                      </div>
                      <Panel>
                        {(action === 'create' || action === 'update') &&
                          <CostitemFormComponent backlink={'/finance/cost-item'}/>
                        }
                      </Panel>
                    </div>
                  </Sidebar>
                }

      {entity === 'vat-rate' && (!action || action === 'update' || action === 'create') &&
        <div className={"PageContent p-p-5 p-mx-auto"}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
              <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                Áfa kulcsok listája
              </h2>
            </div>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
              <span className={"p-mr-2"}>

              </span>
              <a onClick={() => {
                history.push('/finance/vat-rate/create')
              }}
                  className={"p-button  p-button-success p-ml-2"}>
                <i className={"pi pi-plus"}></i>
                &nbsp;
                Új áfa kulcs
              </a>
            </div>
          </div>
          <Panel>
            <VatrateListComponent backlink={'/finance/vat-rate'}/>
          </Panel>
        </div>
      }
      {entity === 'vat-rate' && (action === 'create' || action === 'update') &&
        <Sidebar position="left"
                  showCloseIcon={false}
                  visible={action === 'create' || action === 'update'}
                  closeOnEscape={true}
                  style={{width: '780px'}}
                  onHide={() => {
                    if (action === 'create' || action === 'update') {
                      history.push('/finance/vat-rate')
                    }
                  }}>
          <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  Áfa kulcs {id ? (<>módosítása</>) : (<>létrehozása</>)}
                </h2>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
              <span className={"p-mr-2"}>

              </span>
                <a onClick={() => {
                  if (action === 'create' || action === 'update') {
                    history.push('/finance/vat-rate')
                  }
                }}
                    className={"p-button  p-button-secondary p-ml-2"}>
                  <i className={"pi pi-arrow-left"}></i>
                  &nbsp;
                  Vissza
                </a>
              </div>
            </div>
            <Panel>
              {(action === 'create' || action === 'update') &&
                <VatrateFormComponent backlink={'/finance/vat-rate'}/>
              }
            </Panel>
          </div>
        </Sidebar>
      }
      {entity === 'cost-center' && (action === 'create' || action === 'update') &&
        <Sidebar position="left"
                  showCloseIcon={false}
                  visible={action === 'create' || action === 'update'}
                  closeOnEscape={true}
                  style={{width: '780px'}}
                  onHide={() => {
                    if (action === 'create' || action === 'update') {
                      history.push('/finance/cost-center')
                    }
                  }}>
          <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  Költséghely {id ? (<>módosítása</>) : (<>létrehozása</>)}
                </h2>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
              <span className={"p-mr-2"}>

              </span>
                <a onClick={() => {
                  if (action === 'create' || action === 'update') {
                    history.push('/finance/cost-center')
                  }
                }}
                    className={"p-button  p-button-secondary p-ml-2"}>
                  <i className={"pi pi-arrow-left"}></i>
                  &nbsp;
                  Vissza
                </a>
              </div>
            </div>
            <Panel>
              {(action === 'create' || action === 'update') &&
                <CostcenterFormComponent backlink={'/finance/cost-center'}/>
              }
            </Panel>
          </div>
        </Sidebar>
      }
























      
      {/* REFAKTORÁLVA 2.1-RE */}
      {!entity &&
        <>
          {localStorage.getItem('module_finance') ? (
            <>
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <ReceiptListComponent view="simple"
                  receiptGroup={fromReceiptGroup ? receiptGroupFromUrl : undefined}
                  receiptType={fromReceiptGroup ? receiptTypeFromUrl : undefined}
                  receiptGroupName={fromReceiptGroup ? receiptGroupNameFromUrl : undefined}/>
              </div>
              <Sidebar position="left" visible={window.App.state.sidebarReceiptList} closeOnEscape={true}
                       style={{width: '100%'}}
                       onHide={() => window.App.setState({
                         sidebarReceiptList: false,
                         lazyparamsReceiptList: null,
                       })}>
                <ReceiptListComponent view="advanced"/>
              </Sidebar>
              <Sidebar position="left" visible={window.App.state.sidebarReceiptCostCreate} closeOnEscape={true}
                       style={{width: '98%'}}
                       onHide={() => window.App.setState({
                         rerenderReceiptList: true,
                         sidebarReceiptCostCreate: false,
                         newPartnerId: null,
                         newPartnerName: null
                       })}>
                <ReceiptFormComponent method="post"/>
              </Sidebar>
              <Sidebar position="left" visible={window.App.state.sidebarReceiptUpdate} closeOnEscape={true}
                       style={{width: '98%'}}
                       onHide={() => window.App.setState({
                         rerenderReceiptList: true,
                         sidebarReceiptUpdate: false,
                         newPartnerId: null,
                         newPartnerName: null
                       })}>
                <ReceiptFormComponent method="put" initialValues={window.App.state.props}/>
              </Sidebar>
              <Sidebar position="left" visible={window.App.state.sidebarReceiptInvoiceCreate} closeOnEscape={true}
                       style={{width: '98%'}}
                       onHide={() => {
                         window.App.setState({
                           rerenderReceiptList: true,
                           sidebarReceiptInvoiceCreate: false,
                           newPartnerId: null,
                           newPartnerName: null
                         })
                       }}>
                <ReceiptFormComponent method="post"/>
              </Sidebar>
              <Sidebar position="left" visible={window.App.state.sidebarReceiptDeliveryNoteCreate} closeOnEscape={true}
                       style={{width: '98%'}}
                       onHide={() => {
                         window.App.setState({
                           rerenderReceiptList: true,
                           sidebarReceiptDeliveryNoteCreate: false,
                           newPartnerId: null,
                           newPartnerName: null
                         })
                       }}>
                <ReceiptFormComponent method="post"/>
              </Sidebar>
              <Sidebar position="left" visible={window.App.state.sidebarReceiptFeeRequestCreate} closeOnEscape={true}
                       style={{width: '98%'}}
                       onHide={() => {
                         window.App.setState({
                           rerenderReceiptList: true,
                           sidebarReceiptFeeRequestCreate: false,
                           newPartnerId: null,
                           newPartnerName: null
                         })
                       }}>
                <ReceiptFormComponent method="post"/>
              </Sidebar>
              <Sidebar position="left" visible={window.App.state.sidebarReceiptCostImport} closeOnEscape={true}
                       style={{width: '780px'}}
                       onHide={() => {
                         window.App.setState({
                           sidebarReceiptCostImport: false,
                           newPartnerId: null,
                           newPartnerName: null
                         })
                       }}>
                <h2 className={"text-primary"}>Költségszámlák importálása</h2>
                <ReceiptCostImportComponent method="post"/>
              </Sidebar>
              <Sidebar position="left" visible={window.App.state.sidebarReceiptSzamlazzhuImport} closeOnEscape={true}
                       style={{width: '780px'}}
                       onHide={() => {
                         window.App.setState({
                           sidebarReceiptSzamlazzhuImport: false,
                           newPartnerId: null,
                           newPartnerName: null
                         })
                       }}>
                <h2 className={"text-primary"}>Számlázz.hu importálás</h2>
                <ReceiptSzamlazzhuImportComponent method="post"/>
              </Sidebar>
              {/* <Sidebar position="left" visible={window.App.state.sidebarReceiptShow} closeOnEscape={true}
                      style={{width: '980px'}}
                      onHide={() => window.App.setState({
                        rerenderReceiptList: true,
                        sidebarReceiptShow: false,
                        newPartnerId: null,
                        newPartnerName: null
                      })}>
              </Sidebar> */}
              <Dialog visible={window.App.state.dialogReceiptSend}
                      style={{width: '450px'}}
                      header="Számla kézbesítése emailben"
                      modal
                      onHide={() => {
                        window.App.setState({dialogReceiptSend: false})
                      }}>
                <ReceiptSendComponent/>
              </Dialog>
            </>
          ) : (
            <p className={"p-text-center p-my-5 p-py-5"}>
              <i className={"pi pi-exclamation-circle p-d-block p-mb-5"} style={{'fontSize': '5em'}}></i>
              <span className={"p-text-bold p-d-block "}>Ehhez a modulhoz sajnos nem rendelkezel hozzáféréssel.</span>
              Amennyiben további információra van szükséged írj emailt a {process.env.REACT_APP_DEVOPS_CONTACT} címre.
              {process.env.REACT_APP_SUBSCRIPTIONS === 'enabled' &&
                <span className={"p-text-bold p-d-block p-mt-5"}>
                       <a className={"p-button p-button-warning"}
                          onClick={() => {
                            window.location.replace('/#/subscriptions');
                            window.App.forceUpdate()
                          }}
                       >
                         <i className={"pi pi-building"}></i>&nbsp;Előfizetői fiók áttekintése
                       </a>
                   </span>
              }
            </p>
          )}
        </>
      }
    </div>
  )
}
export default withTranslation('common')(FinanceDashboardPage);
